export default __webpack_public_path__ + "static/media/Icons__thermostat3.9de825d0.svg";